export * from './getAllDesktopSettings'
export * from './setActiveWallpaper'
export * from './uploadWallpaper'
export * from './deleteWallpaper'
export * from './pinApp'
export * from './unpinApp'
export * from './updatePinnedAppsOrder'
export * from './getWidgets'
export * from './saveWidgets'
export * from './deleteWidget'
export * from './setWidgetBarLocation'
export * from './getApps'
export * from './getDownloadableApps'
export * from './getTutorialVideos'
export * from './getFeatureFlags'
export * from './getPredefinedWallpaperAnimation'
